import { observer } from 'mobx-react-lite'
import RectButton, { RectButtonProps } from './RectButton'

interface Props extends Omit<RectButtonProps, 'variant'> {
  selected: boolean
  variant?: 'contained' | 'outlined'
}

const SelectableRectButton = observer((props: Props) => {
  const { selected, variant = 'outlined', ...rest } = props

  const styleKey = variant + (selected ? 'Selected' : 'Unselected')

  const buttonStyles = {
    containedSelected: {
      variant: 'contained' as const,
    },
    outlinedSelected: {
      variant: 'outlined' as const,
    },
    containedUnselected: {
      variant: 'outlined' as const,
    },
    outlinedUnselected: {
      variant: 'outlined' as const,
      color: 'darkGray' as const,
    },
  }[styleKey]

  return <RectButton
    {...rest}
    {...buttonStyles}
  />
})

export default SelectableRectButton